import { render, staticRenderFns } from "./RiskMitigationActionAdd.vue?vue&type=template&id=2f38a086&"
import script from "./RiskMitigationActionAdd.vue?vue&type=script&lang=js&"
export * from "./RiskMitigationActionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports